// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    name: "PRODUCTION",
    production: true,
    host_portal: "portal.mrpresta.com",
    portal_url: "https://portal.ms.mrpresta.com/",
    scs_url: "https://scs.mrpresta.com",
    portal_client_secret: "JZqlvAZTlKyirqKMjhffWImlsDaI6Ohiu9ej8YI0",
    scs_client_id: "f3d259ddd3ed8ff3843839b",
    scs_client_secret: "4c7f6f8fa93d59c45502c0ae8c4a95b",
    scs_grant_type: "password",
    scs_password: "MrpLambda",
    scs_username: "developers@mrpresta.com",
    scs_url_lh: 'https://api.mrpresta.com/api',
    firebaseConfig: {
      apiKey: "AIzaSyDZc6Rwu0DbwoP55EdBCK4AfwvyQzEeW_4",
      authDomain: "mrpresta.firebaseapp.com",
      projectId: "mrpresta",
      storageBucket: "mrpresta.appspot.com",
      messagingSenderId: "1037475903404",
      appId: "1:1037475903404:web:ce94181ec1edcd9459ac09",
      measurementId: "G-VPM0X0ZKRG"
   }
};
